import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AswMasterHelper } from '@common/helpers/utilities/asw-master-helper';
import { MListData } from '@common/interfaces/master/m_list_data';
import { LOAD_MASTERS } from '@common/master';
import { ServicingCommonStoreService } from '@common/services';
import { MyBookingServiceService } from '@common/services/my-booking/my-booking-service/my-booking-service.service';
import { SupportModalBlockComponent } from '@lib/components/support-class';
import { AswContextType } from '@lib/interfaces';
import { CommonLibService } from '@lib/services';
import { map } from 'rxjs';
import { LanguageSelectionPayload } from './language-selection-modal.payload';

@Component({
  selector: 'asw-agreement',
  templateUrl: './language-selection-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSelectionModalComponent extends SupportModalBlockComponent {
  public subPageId: string = '';

  public subFunctionId: string = '';

  /** 言語切り替え判定の初期値 */
  public isChangeLang = false;

  public override payload: LanguageSelectionPayload | null = {};

  /** [13.2] 言語選択 */
  private readonly langList: Array<{ code: string; label: string }> = [
    { code: 'ja', label: 'Japanese' },
    { code: 'en', label: 'English' },
  ];

  public langFormControl = new FormControl('ja');

  /** [13.1] 言語切り替え案内 */
  messageContent: string = '';

  constructor(
    private _common: CommonLibService,
    private _router: Router,
    public change: ChangeDetectorRef,
    private servicingCommonService: ServicingCommonStoreService,
    private readonly _myBookingServiceService: MyBookingServiceService,
    private readonly aswMasterHelper: AswMasterHelper
  ) {
    super(_common);
    this.closeWithUrlChange(this._router);
  }

  mListData = () => this.aswMasterHelper.get_aswdb_observable<MListData>(LOAD_MASTERS.LISTDATA_ALL.key);

  init() {
    this.messageContent = this.payload?.messageExplain ?? this._myBookingServiceService.onHandleCommonNo11();
  }

  refresh() {
    this.cancelEvent();
    this.continueEvent();
  }

  destroy(): void {}

  reload(): void {}

  // 「キャンセル」ボタン押下処理（言語選択モーダル）
  cancelEvent() {
    this.servicingCommonService.updateServicingCommon({
      lang: '',
    });
    this.payload?.cancelEvent?.();
    this.close();
  }

  /** (18)「選択する」ボタン押下処理 (言語選択モーダル) */
  continueEvent() {
    const aswLangCode = this._common.aswContextStoreService.aswContextData.lang ?? '';
    /**
     * 1.言語選択モーダルを表示する。 言語選択モーダルをアレンジし、そのアレンジした画面を言語選択モーダル(利用言語選択ダイアログ)を表示し、選択した言語に切り替えする。
     * サービシング共通store.言語コードにユーザ共通.言語情報を保持する。
     */
    this.servicingCommonService.updateServicingCommon({
      lang: this.langFormControl.value ?? '',
      backupLanguage: aswLangCode,
    });
    /**
     * サービシング共通store.言語コードにユーザ共通.言語情報を保持する。
     * ユーザ共通.言語情報に選択した言語を保持する。
     * 選択した言語（enまたは、ja）はawsContext.langに保持する。
     */
    this._common.aswContextStoreService.updateAswContextByKey(AswContextType.LANG, this.langFormControl.value);

    /** (18.2) マイカーバレー申込(S02-P011)へ遷移する */
    this.payload?.continueEvent?.();
    this.close();
  }

  /** [13.2] 言語選択 */
  languageList = this.mListData().pipe(
    map((mListData) => {
      const langCodeList = this.langList.map((lang) => lang.code);

      const filteredMListData = mListData
        .filter(
          (item) =>
            // データコード ＝ “PD_065” AND 言語コード ＝ ユーザ共通.言語情報 AND value IN ('ja', 'en')
            item.data_code === 'PD_065' &&
            langCodeList.includes(String(item.value)) &&
            this._common.aswContextStoreService.aswContextData.lang === item.lang
        )
        .map((item) => ({
          // 汎用マスターデータ(リスト).value値を言語選択.値へ設定する。
          code: item.value,
          // 汎用マスターデータ(リスト).表示内容を言語選択.ラベルへ設定する。
          label: item.display_content,
        }));

      const languageList: typeof filteredMListData = [];
      // ソート順
      // 'ja', 'en'
      filteredMListData.forEach((item) => {
        const itemIndex = langCodeList.indexOf(String(item.code));
        if (itemIndex > -1) {
          languageList.splice(itemIndex, 0, item);
        }
      });
      return languageList;
    })
  );
}
